<div
  *ngIf="!is_read_running"
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast sp-padding__x2">
  <div class="sp-row__space sp-padding">
    <h3 class="sp-color__primary">JSON</h3>
  </div>

  <div
    *ngIf="!qinetic_position"
    class="sp-padding__x12">
    <div class="sp-margin__bottom sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
    <p class="sp-text__center sp-color__primary">{{ 'ORDER_DETAILS.DECIDO_NOT_FOUND_LABEL' | translate }}</p>
    <div class="sp-margin__top sp-stroke sp-stroke__dashed-dark sp-width__full"></div>
  </div>
  <div
    *ngIf="qinetic_position"
    class="sp-padding__x2">
    <pre style="white-space: pre-wrap; word-break: break-all"> {{ qinetic_position | json }} </pre>
  </div>
</div>

<div
  *ngIf="is_read_running"
  class="sp-width__full sp-height__full sp-border-radius__s sp-background__accent-contrast">
  <app-loading [card_radius]="'sp-border-radius__s'"></app-loading>
</div>
